import React, { useEffect, useState } from "react";
import { Text, Flex, Card, Box, VStack } from "@chakra-ui/react";
import BackButton from "../components/BackButton";
import { useAuth } from "../context/AuthContext";
import axiosInstance from "../routes/axiosInstance";
import CallHistory from "../components/calls/CallHistory";

const CallListPage = () => {
  const { currentUser, checkUserAuth } = useAuth();
  const [callLoading, setCallLoading] = useState(false);
  const [callHistoryData, setCallHistoryData] = useState({});

  const getUserCallHistory = async () => {
    setCallLoading(true);
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${currentUser.token}`,
      },
    };

    try {
      const { data } = await axiosInstance.get(`/api/calls`, config);
      setCallHistoryData(data);
      setCallLoading(false);
    } catch (error) {
      console.log(error.message);
      setCallLoading(false);
      checkUserAuth(error.status);
    }
  };

  useEffect(() => {
    getUserCallHistory();
  }, []);

  return (
    <Box bg="gray.50" minH="100vh">
      <Flex direction="column" h="100vh" maxW="md" mx="auto">
        {/* Header */}
        <Card
          bg="white"
          borderRadius="none"
          borderBottom="1px solid"
          borderColor="gray.200"
          p={3}
          boxShadow="sm"
        >
          <Flex align="center" spacing={3}>
            <BackButton link={`/chats`} />
            <Text fontSize="lg" fontWeight="600" color="gray.800" ml={3}>
              Calls
            </Text>
          </Flex>
        </Card>

        {/* Call History */}
        <Box
          flex="1"
          bg="white"
          borderLeft="1px solid"
          borderRight="1px solid"
          borderColor="gray.200"
          overflowY="auto"
        >
          {callHistoryData.data && callHistoryData.data.length > 0 ? (
            <CallHistory
              callList={callHistoryData.data}
              loading={callLoading}
            />
          ) : callLoading ? (
            <Box p={4}>
              <CallHistory callList={[]} loading={callLoading} />
            </Box>
          ) : (
            <Flex align="center" justify="center" h="full">
              <VStack spacing={4} textAlign="center">
                <Text fontSize="lg" color="gray.500" fontWeight="500">
                  No call history
                </Text>
                <Text fontSize="sm" color="gray.400">
                  Start a call to see your call history here
                </Text>
              </VStack>
            </Flex>
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default CallListPage;
